import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const concludePostPurchaseAbTest = {
  name: "concludePostPurchaseAbTest" as const,
  input: z.object({
    splitId: zExt.objectId(),
    selectedTreatmentId: zExt.objectId(),
  }),
  output: z.null(),
};
